import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { fetchVehicleStatusDetails } from 'store/vehicles/actions';
import VehicleStatusDetails from './VehicleStatusDetails';

export default compose(
  connect(
    (state) => ({
      responseDialog: state.vehicles.responseDialog,
      showTitle: false,
      vehicleStatusDetails: state.vehicles.vehicleStatusDetails,
    }),
    { fetchVehicleStatusDetails }
  )
)(VehicleStatusDetails);
